import { AWSUser } from "@archetypes/auth";
import { fetchAuthSession, fetchUserAttributes } from "aws-amplify/auth";

export const getUser = async (): Promise<AWSUser | undefined> => {
  try {
    const attributes = await fetchUserAttributes();
    return attributes as unknown as AWSUser;
  } catch (error) {
    return undefined;
  }
};

export const getJWTToken = async (): Promise<string | undefined> => {
  try {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString();
  } catch (error) {
    return undefined;
  }
};
